import { render, staticRenderFns } from "./MppMoneyRecordIn.vue?vue&type=template&id=d2048d14&scoped=true&"
import script from "./MppMoneyRecordIn.vue?vue&type=script&lang=js&"
export * from "./MppMoneyRecordIn.vue?vue&type=script&lang=js&"
import style0 from "./MppMoneyRecordIn.vue?vue&type=style&index=0&id=d2048d14&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2048d14",
  null
  
)

export default component.exports